import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Overview from "../../img/nanologo.svg";
import OverviewCurta from "../../img/nlogo.svg";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ModalVersao from "../../components/modalVersion";
import ModalLogout from "../../components/modalLogout";

function CustomNavbar({ sidebarOpen }) {
  const [showModalVersion, setShowModalVersion] = useState(false);
  const handleShowModalVersion = () => setShowModalVersion(true);
  const handleCloseModalVersion = () => setShowModalVersion(false);

  const [showModalLogout, setShowModalLogout] = useState(false);
  const handleShowModalLogout = () => setShowModalLogout(true);
  const handleCloseModalLogout = () => setShowModalLogout(false);

  const [userInitials, setUserInitials] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.user?.name;
    if (userName) {
      const [firstName, ...rest] = userName.trim().split(" ");
      const lastName = rest.length ? rest[rest.length - 1] : "";
      if (lastName) {
        const initials = `${firstName[0]}${lastName[0]}`.toUpperCase();
        setUserInitials(initials);
      } else {
        const initials = `${firstName[0].toUpperCase()}`;
        setUserInitials(initials);
      }
    }
  }, []);

  return (
    <>
      <Navbar className="menu-top">
        <Container className="menu">
          <Link to="/">
            <img
              src={sidebarOpen ? Overview : OverviewCurta}
              alt={sidebarOpen ? "Overview" : "Overview logo"}
              className={` ${sidebarOpen ? "img-sidebar" : "img-navbar-short"}`}
              width="100%"
              height="100%"
            />
          </Link>
          <div className="d-inline-flex align-items-center">
            <Link
              title="Página de perfil"
              className="user-initials btn-table img-user"
              to={"/perfil"}
            >
              {userInitials}
            </Link>
            <button
              className="btn-table bi bi-question-circle img-user"
              onClick={handleShowModalVersion}
            ></button>
            {/* <Link
              title="Página de logs"
              className="btn-table bi bi-info-circle img-user"
              to={"/logs"}
            ></Link> */}
            <button
              className="btn-table bi bi-box-arrow-right img-user "
              onClick={handleShowModalLogout}
            ></button>
          </div>
        </Container>
      </Navbar>
      <ModalVersao show={showModalVersion} onHide={handleCloseModalVersion} />
      <ModalLogout show={showModalLogout} onHide={handleCloseModalLogout} />
    </>
  );
}

CustomNavbar.propTypes = {
  sidebarOpen: PropTypes.bool,
};

export default CustomNavbar;
